import FilterModal from "./FilterModal";

export default FilterModal;
